import clsx from 'clsx';
import React from 'react';
import { getRatingStyle } from '@/helpers/ratingState';
import { APP_COLORS } from '@/config/colors';

export interface RateBarsProps {
  maxRating?: number;
  rating?: number;
  className?: string;
  backgroundColors?: string[];
  textColors?: string[];
}

const getRatingColor = (barValue: number, currentValue: number) => {
  if (barValue > currentValue) return `bg-[${APP_COLORS.primary[100]}]`;
  else return getRatingStyle(currentValue);
};

const getCustomRatingColor = (
  barValue: number,
  currentValue: number,
  backgroundColors?: string[],
) => {
  if (barValue > currentValue) return 'bg-gray-200';

  if (!backgroundColors || backgroundColors.length === 0) {
    return getRatingColor(barValue, currentValue);
  }

  // Indeks w tablicy (currentValue - 1, bo rating zaczyna się od 1)
  const colorIndex = currentValue - 1;

  // Jeśli mamy kolor dla tego ratingu, użyj go
  if (colorIndex < backgroundColors.length) {
    return backgroundColors[colorIndex];
  }

  // Fallback do zielonego koloru jeśli maxRating > długość tablicy
  return 'bg-green-700';
};

export default function RateBars({
  maxRating = 5,
  rating = 0,
  className,
  backgroundColors,
}: RateBarsProps) {
  const bars = Array.from({ length: maxRating }, (_, index) => index + 1);

  return (
    <div className={clsx('pr-5', className)}>
      <div className="flex flex-col-reverse gap-1">
        {bars.map((bar) => (
          <div
            key={bar}
            className={clsx(
              'h-[12px] w-[36px] rounded-[5px]',
              getCustomRatingColor(bar, rating, backgroundColors),
            )}
          />
        ))}
      </div>
    </div>
  );
}
